<template>
  <div>
    <div class="type-filter">
      <span class="filter-title pc">
        <span class="text">{{ name }}</span>：
      </span>
      <div class="type-list pc">
        <span
          class="type-item"
          :class="{'selected': selectedType === 0 }"
          v-if="hasWholeType"
          @click="handleSelect(0)"
        >{{ wholeTypeName }}</span>
        <span
          class="type-item"
          :class="{'selected': selectedType === item.id }"
          v-for="(item, index) in types"
          :key="index"
          @click="handleSelect(item)"
        >{{ item.name }}</span>
      </div>
    </div>
    <el-select
      class="mobile"
      popper-class="type-filter-select"
      v-model="selectedType"
      @change="handleSelectChange"
      :placeholder="name"
    >
      <el-option v-if="hasWholeType" :label="wholeTypeName + ' ' + name" :value="0"></el-option>
      <el-option v-for="(item, index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "typeFilter",
  props: {
    name: {
      type: String,
      required: true
    },
    hasWholeType: {
      type: Boolean,
      default: true
    },
    wholeTypeName: {
      type: String,
      required: true
    },
    types: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    },
    defaultType: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      selectedType: this.defaultType
    };
  },
  methods: {
    handleSelect(item) {
      if (item === 0) {
        this.selectedType = 0;
      } else {
        this.selectedType = item.id;
      }

      this.$emit("type-change", this.selectedType);
    },
    handleSelectChange(val) {
      this.$emit("type-change", val);
    }
  }
};
</script>

<style scoped>
.type-filter {
  position: relative;
  font-size: 14px;
  line-height: 22px;
}

.filter-title {
  position: absolute;
  font-weight: bold;
}

.filter-title .text {
  display: inline-block;
  width: 56px;
  height: 22px;
  text-align: justify;
  vertical-align: bottom;
  overflow: hidden;
}

.filter-title .text:after {
  content: "";
  display: inline-block;
  width: 100%;
}

.type-list {
  padding-left: 78px;
}

.type-item {
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 8px;
  padding: 0 6px;
  cursor: pointer;
}

.type-item.selected {
  color: #fff;
  background-color: #d9ae73;
  border-radius: 2px;
}

.tjxd .type-item.selected {
  background-color: #ec2f08;
}
.hnkc .type-item {
  margin-bottom: 16px;
}
.hnkc .type-item.selected {
  background-color: #ff4100;
}

@media (max-width: 767px) {
}
</style>

<style lang="scss">
.type-filter-select {
  .el-select-dropdown__item.selected {
    color: #b92e32 !important;
  }
}
</style>
